<template>
  <div>
    <div>
      <h3><strong>Important references</strong></h3>
      <ul class="list-group">
        <li>
          <strong>Sun,B.B. et al.</strong>
          Genomic atlas of the human plasma proteome.
          <i>Nature</i>
          558, 73–79 (2018)
        </li>
        <li>
          <strong>Emilsson,V. et al.</strong>
          Co-regulatory networks of human serum proteins link genetics to
          disease.
          <i>Science</i>
          361(6404), 769-773 (2018)
        </li>
        <li>
          <strong>Suhre,K. et al.</strong>
          Connecting genetic risk to disease end points through the human blood
          plasma proteome.
          <i>Nat Commun</i>
          8, 14357 (2017)
        </li>
        <li>
          <strong>Folkersen,L. et al.</strong>
          Mapping of 79 loci for 83 plasma protein biomarkers in cardiovascular
          disease.
          <i>PLoS Genet</i>
          13, e1006706 (2017)
        </li>
        <li>
          <strong>Yao,C. et al.</strong>
          Genome-wide mapping of plasma protein QTLs identifies putatively
          causal genes and pathways for cardiovascular disease.
          <i>Nat Commun</i>
          9(1), 3268 (2018)
        </li>
      </ul>
    </div>

    <div class="py-3"></div>

    <b-row>
      <b-col>
        <h4><strong>Proteome MR writing group</strong></h4>
        <p>
          <a
            href="http://www.bristol.ac.uk/social-community-medicine/people/jie-zheng/index.html"
          >
            Jie Zheng
          </a>
        </p>
        <p>
          <a
            href="http://www.bristol.ac.uk/social-community-medicine/people/valeriia-haberland/index.html"
          >
            Valeriia Haberland
          </a>
        </p>
        <p>
          <a
            href="http://www.bristol.ac.uk/social-community-medicine/people/denis-a-baird/index.html"
          >
            Denis Baird
          </a>
        </p>
        <p>
          <a
            href="http://www.bristol.ac.uk/social-community-medicine/people/venexia-v-walker/index.html"
          >
            Venexia Walker
          </a>
        </p>
        <p>
          <a
            href="http://www.bristol.ac.uk/social-community-medicine/people/philip-c-haycock/index.html"
          >
            Philip Haycock
          </a>
        </p>
        <p>
          <a
            href="http://www.bristol.ac.uk/social-community-medicine/people/george-davey-smith/index.html"
          >
            George Davey Smith
          </a>
        </p>
        <p>
          <a
            href="https://www.phpc.cam.ac.uk/people/ceu-group/ceu-senior-academic-staff/adam-butterworth/"
          >
            Adam S. Butterworth
          </a>
        </p>
        <p>
          <a
            href="http://www.bristol.ac.uk/social-community-medicine/people/gibran-hemani/index.html"
          >
            Gibran Hemani
          </a>
        </p>
        <p>
          <a
            href="https://scholar.google.co.uk/citations?user=oBzdnfgAAAAJ&hl=en"
          >
            Robert A. Scott
          </a>
        </p>
        <p>
          <a
            href="http://www.bristol.ac.uk/social-community-medicine/people/tom-r-gaunt/index.html"
          >
            Tom R. Gaunt
          </a>
        </p>
      </b-col>
      <b-col>
        <h4><strong>Browser development team</strong></h4>
        <p>
          <a
            href="http://www.bristol.ac.uk/social-community-medicine/people/valeriia-haberland/index.html"
          >
            Valeriia Haberland
          </a>
        </p>
        <p>
          <a
            href="http://www.bristol.ac.uk/social-community-medicine/people/benjamin-l-elsworth/index.html"
          >
            Benjamin Elsworth
          </a>
        </p>
        <p>
          <a
            href="http://www.bristol.ac.uk/social-community-medicine/people/yi-liu/index.html"
          >
            Yi Liu
          </a>
        </p>
        <p>
          <a
            href="http://www.bristol.ac.uk/social-community-medicine/people/jie-zheng/index.html"
          >
            Jie Zheng
          </a>
        </p>
        <p>
          <a
            href="http://www.bristol.ac.uk/social-community-medicine/people/tom-r-gaunt/index.html"
          >
            Tom R Gaunt
          </a>
        </p>
      </b-col>
      <b-col>
        <h4><strong>Funding</strong></h4>
        <b-row>
          <b-col>
            <a href="http://www.bristol.ac.uk/integrative-epidemiology/">
              <img
                src="@/assets/linked-resources/MRC_IEU.png"
                alt="MRC IEU"
                width="150"
                height="50"
              />
            </a>
          </b-col>
          <b-col>
            <a href="https://www.gsk.com/">
              <img
                src="@/assets/linked-resources/gsk_logo.jpg"
                alt="GSK"
                width="100"
                height="80"
              />
            </a>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <a href="https://www.biogen.com/en_us/home.html">
              <img
                src="@/assets/linked-resources/logo-biogen.jpg"
                alt="Biogen"
                width="150"
                height="80"
              />
            </a>
          </b-col>
          <b-col>
            <a href="https://www.cancerresearchuk.org/">
              <img
                src="@/assets/linked-resources/cruk_logo.jpg"
                alt="Cancer Research UK"
                width="150"
                height="100"
              />
            </a>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "HomeDoc2",
};
</script>
